'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('sessionService', function($q, apiEndpointFactory, otppConstants, $cookies,$rootScope) {
  let tokenStorageKey = otppConstants.tokenStorageKey;
  let skipOutageKey = otppConstants.skipOutageKey;
  let mbrAuthKey = otppConstants.mbrAuthKey;
  let bamKey = otppConstants.bamKey;
  let accountEndpoint = apiEndpointFactory.new({
    endpointUrl: '/account',
    allowedMethods: ['post'],
    authRequired: true
  });
  let sessionIsValid = $q.defer();
  let inFlight;

  function getTokenInternal() {
    return $cookies.get(tokenStorageKey);
  }

  function checkValidity(sessionToken) {
    inFlight = true;
    return accountEndpoint.post({id: sessionToken}).then(function(response) {
      $rootScope.$broadcast('otppLogin.loginSuccess');
      sessionIsValid.resolve(response.data);
    }, function(response) {
      sessionIsValid.reject({status: response.status});
    }).finally(function() {
      inFlight = false;
      sessionIsValid = $q.defer();
    });
  }

  return {
    getToken: getTokenInternal,
    clearToken: function() {
      this.resetSessionCheck();
      $cookies.remove(tokenStorageKey);
      $cookies.remove(skipOutageKey);
      $cookies.remove(mbrAuthKey, {path: '/'});
      $cookies.remove(bamKey);
      $cookies.remove('mbr.irn');
    },
    setToken: function(token) {
      this.resetSessionCheck();
      $cookies.put(tokenStorageKey, token, [{samesite: 'none'}, {Secure: ''}]);
    },
    validSession: function(checkLoginLoading) {
      if($cookies.get('newsession')){
        $cookies.remove('newsession');
        return this.auth0_init_login();
      }
      
      let sessionToken = getTokenInternal();
      //DMWS-1157 by default not loginLoading flag, unless specified.
      if ((sessionStorage.getItem("loginLoading")=="true" && checkLoginLoading) || !sessionToken) {
        sessionIsValid.reject({});
        inFlight = false;
      } else if (!inFlight) {
        checkValidity(sessionToken);
      }
      return sessionIsValid.promise;
    },
    resetSessionCheck: function() {
      if (inFlight) {
        sessionIsValid.reject({});
        inFlight = false;
      }
      sessionIsValid = $q.defer();
      return sessionIsValid.promise;
    },
    auth0_init_login: function(){
      let loginService=angular.element(document.body).injector().get('loginService');
      return loginService.doLogin();
    }
  };
});


